import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../services/local.storage.service';
import { CoreService } from '../services/core.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private coreService = inject(CoreService);
  private lsService = inject(LocalStorageService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken: string | null = this.lsService.get('accessToken');
    const isPublicApi = request.headers.keys()?.includes('Public');

    request = request.clone({
      setHeaders: {
        'X-FR8BOT-API-TOKEN': 'et8pge2wk0gh8frxiwwgcyb0g90pjw3y',
        'X-FR8BOT-TAB-ID': this.coreService.tabId() ?? '',
      },
    });

    if (!isPublicApi && accessToken !== null) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    }

    return next.handle(request);
  }
}
